import { render, staticRenderFns } from "./ProjCard.vue?vue&type=template&id=6c10009a"
import script from "./ProjCard.vue?vue&type=script&lang=ts"
export * from "./ProjCard.vue?vue&type=script&lang=ts"
import style0 from "./ProjCard.vue?vue&type=style&index=0&id=6c10009a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports